import { t } from 'ttag';

// The one event-language catalog (flux docs/flux/locale_rules.md). `tag` is the
// canonical BCP 47 tag every `language_tag` API field accepts byte-for-byte.
const EVENT_LANGUAGES = () => [
  { label: t`Arabic`, tag: 'ar' },
  { label: t`Chinese (Simplified)`, tag: 'zh' },
  { label: t`Chinese (Traditional)`, tag: 'zh-Hant' },
  { label: t`Czech`, tag: 'cs' },
  { label: t`Danish`, tag: 'da' },
  { label: t`Dutch`, tag: 'nl' },
  { label: t`English`, tag: 'en' },
  { label: t`English (UK)`, tag: 'en-GB' },
  { label: t`Estonian`, tag: 'et' },
  { label: t`Finnish`, tag: 'fi' },
  { label: t`French`, tag: 'fr' },
  { label: t`French (CA)`, tag: 'fr-CA' },
  { label: t`German`, tag: 'de' },
  { label: t`Hungarian`, tag: 'hu' },
  { label: t`Indonesian`, tag: 'id' },
  { label: t`Italian`, tag: 'it' },
  { label: t`Japanese`, tag: 'ja' },
  { label: t`Korean`, tag: 'ko' },
  { label: t`Norwegian`, tag: 'nb' },
  { label: t`Polish`, tag: 'pl' },
  { label: t`Portuguese`, tag: 'pt' },
  { label: t`Portuguese (BR)`, tag: 'pt-BR' },
  { label: t`Russian`, tag: 'ru' },
  { label: t`Spanish`, tag: 'es' },
  { label: t`Swedish`, tag: 'sv' },
  { label: t`Turkish`, tag: 'tr' },
];

export const list = (sorted = true, locale = 'en') => {
  const src = EVENT_LANGUAGES();

  if (!sorted) {
    return src;
  }

  if (sorted && (typeof locale === 'undefined' || locale === null)) {
    throw new Error('locale is require for sorting');
  }

  return src.sort((first, second) =>
    first.label.localeCompare(second.label, locale, { sensitivity: 'accent' }),
  );
};
